import request, { authOptions } from 'api/requestUtils'

const METASEARCH_VOUCHER_API_TIMEOUT_MS = 5000

export interface CreateMetasearchDiscountVoucherInput {
  accountType?: string
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  occupancy: Array<string>
  region: string
  isCugRate: boolean
  mx?: string
  /**
   * Google's raw stored rate-rule ID, forwarded verbatim so voucher entitlement resolves against
   * the same rule Google selected. Optional — absent for non-country / already-cached traffic.
   */
  rateRuleId?: string
  bedbankSessionId?: string
}

export interface CreateMetasearchDiscountVoucherResponse {
  voucherId?: string
}

export function createMetasearchDiscountVoucher(
  input: CreateMetasearchDiscountVoucherInput,
): Promise<CreateMetasearchDiscountVoucherResponse> {
  return request.post<CreateMetasearchDiscountVoucherResponse, CreateMetasearchDiscountVoucherInput>(
    '/api/connections/google/discount-voucher',
    input,
    {
      ...authOptions(),
      timeout: METASEARCH_VOUCHER_API_TIMEOUT_MS,
    },
  ).then(response => ({
    voucherId: response?.voucherId,
  })).catch(() => ({
    voucherId: undefined,
  }))
}
